import { useTranslation } from 'react-i18next';

import type { IncidentState } from '@/signalr';
import { useRegisterActionsMobileMenuContainer } from './actionsMobileMenu';
import { MobileMenuButtonItem } from './MobileMenuButtonItem';

export type MobileMenuMoreSubmenuProps = {
  incidentState: IncidentState | null;
};

export function MobileMenuMoreSubmenu(props: MobileMenuMoreSubmenuProps) {
  void props;
  const { t } = useTranslation();
  const registerContainer = useRegisterActionsMobileMenuContainer();

  return (
    <div className="mobile-menu-more-submenu btn-group dropup">
      <MobileMenuButtonItem icon="fa-light fa-ellipsis" title={t('Incident_MobileLayout_TabButton_More')} isDropdown />

      <ul className="dropdown-menu" style={{ width: '100vw' }} ref={registerContainer}>
      </ul>
    </div>
  );
}
